"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetNewBlogStage = exports.changeImportExternalBlog = exports.changeSlug = exports.changeDomain = exports.changeName = void 0;

var _CreateNewBlog = _interopRequireWildcard(require("../../stagedObjects/CreateNewBlog"));

var _constants = require("settings-ui-sdk/Blogs/constants");

var changeName = _CreateNewBlog.default.changeProperty(_constants.NAME);

exports.changeName = changeName;

var changeDomain = _CreateNewBlog.default.changeProperty(_constants.DOMAIN);

exports.changeDomain = changeDomain;

var changeSlug = _CreateNewBlog.default.changeProperty(_constants.SLUG);

exports.changeSlug = changeSlug;

var changeImportExternalBlog = _CreateNewBlog.default.changeProperty(_CreateNewBlog.IMPORT_EXTERNAL_BLOG);

exports.changeImportExternalBlog = changeImportExternalBlog;
var resetNewBlogStage = _CreateNewBlog.default.resetChangesToStagedObject;
exports.resetNewBlogStage = resetNewBlogStage;